import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styles from './Footer.module.css';

const Footer = ({ showHealthText = false }) => {
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email) return;
    
        // Construct mailto link
        const subject = encodeURIComponent('Newsletter Subscription');
        const body = encodeURIComponent(`Please subscribe this email: ${email}`);
        const mailtoLink = `mailto:piscesia.info@gmail.com?subject=${subject}&body=${body}`;
    
        // Open mail client
        window.location.href = mailtoLink;
    
        // Optionally reset the input
        setEmail('');
    };
    

    return (
        <footer className={styles.footer}>
            {/* Green Banner - Only show on CSR page */}
            {showHealthText && (
                <div className={styles.greenBanner}>
                    <div className={styles.container}>
                        <p className={styles.bannerText}>
                            Additionally, be of help to them to improve their health conditions.
                        </p>
                    </div>
                </div>
            )}

            {/* Social Media Section */}
            <div className={styles.socialSection}>
                <div className={styles.container}>
                    <div className={styles.socialContainer}>
                        <span className={styles.followText}>Follow PISCESIA</span>
                        <div className={styles.socialIcons}>
                            <a 
                                href="https://www.facebook.com/people/Piscesia-Power-Transmission-Pvt-Ltd/100071216491479" 
                                className={styles.socialIcon} 
                                aria-label="Follow PISCESIA on Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24V15.564H7.078V12.073H10.125V9.413C10.125 6.388 11.917 4.715 14.658 4.715C15.97 4.715 17.344 4.953 17.344 4.953V7.928H15.83C14.34 7.928 13.875 8.83 13.875 9.755V12.073H17.203L16.671 15.564H13.875V24C19.612 23.094 24 18.1 24 12.073Z"/>
                                </svg>
                            </a>
                            <Link href="/" className={styles.socialIcon} aria-label="Follow PISCESIA on Instagram">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M12 2.163C15.204 2.163 15.584 2.175 16.85 2.233C20.102 2.381 21.621 3.924 21.769 7.152C21.827 8.417 21.838 8.797 21.838 12.001C21.838 15.206 21.826 15.585 21.769 16.85C21.62 20.075 20.105 21.621 16.85 21.769C15.584 21.827 15.206 21.839 12 21.839C8.796 21.839 8.416 21.827 7.151 21.769C3.891 21.62 2.38 20.07 2.232 16.849C2.174 15.584 2.162 15.205 2.162 12C2.162 8.796 2.175 8.417 2.232 7.151C2.381 3.924 3.896 2.38 7.151 2.232C8.417 2.175 8.796 2.163 12 2.163ZM12 0C8.741 0 8.333 0.014 7.053 0.072C2.695 0.272 0.273 2.69 0.073 7.052C0.014 8.333 0 8.741 0 12C0 15.259 0.014 15.668 0.072 16.948C0.272 21.306 2.69 23.728 7.052 23.928C8.333 23.986 8.741 24 12 24C15.259 24 15.668 23.986 16.948 23.928C21.302 23.728 23.73 21.31 23.927 16.948C23.986 15.668 24 15.259 24 12C24 8.741 23.986 8.333 23.928 7.053C23.732 2.699 21.311 0.273 16.949 0.073C15.668 0.014 15.259 0 12 0ZM12 5.838C8.597 5.838 5.838 8.597 5.838 12C5.838 15.403 8.597 18.162 12 18.162C15.403 18.162 18.162 15.403 18.162 12C18.162 8.597 15.403 5.838 12 5.838ZM12 16C9.791 16 8 14.209 8 12C8 9.791 9.791 8 12 8C14.209 8 16 9.791 16 12C16 14.209 14.209 16 12 16ZM18.406 4.155C18.406 5.052 17.68 5.778 16.783 5.778C15.886 5.778 15.16 5.052 15.16 4.155C15.16 3.258 15.886 2.532 16.783 2.532C17.68 2.532 18.406 3.258 18.406 4.155Z"/>
                                </svg>
                            </Link>
                            <a
                                href="https://www.linkedin.com/company/piscesia-power-transmission-private-limited/?originalSubdomain=in"
                                className={styles.socialIcon}
                                aria-label="Follow PISCESIA on LinkedIn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M20.447 20.452H16.893V14.883C16.893 13.555 16.866 11.846 15.041 11.846C13.188 11.846 12.905 13.291 12.905 14.785V20.452H9.351V9H12.765V10.561H12.811C13.288 9.661 14.448 8.711 16.181 8.711C19.782 8.711 20.448 11.081 20.448 14.166V20.452H20.447ZM5.337 7.433C4.193 7.433 3.274 6.507 3.274 5.368C3.274 4.23 4.194 3.305 5.337 3.305C6.477 3.305 7.401 4.23 7.401 5.368C7.401 6.507 6.476 7.433 5.337 7.433ZM7.119 20.452H3.555V9H7.119V20.452ZM22.225 0H1.771C0.792 0 0 0.774 0 1.729V22.271C0 23.227 0.792 24 1.771 24H22.222C23.2 24 24 23.227 24 22.271V1.729C24 0.774 23.2 0 22.222 0H22.225Z"/>
                                </svg>
                            </a>
                            <Link href="" className={styles.socialIcon} aria-label="Follow PISCESIA on Twitter">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z"/>
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer */}
            <div className={styles.mainFooter}>
                <div className={styles.container}>
                    <div className={styles.footerGrid}>
                        {/* Get in Touch Column */}
                        <div className={styles.footerColumn}>
                            <div className={styles.logoSection}>
                                <div className={styles.logoContainer}>
                                    <Image
                                        src="/logos/main_logo.png"
                                        alt="PISCESIA Logo"
                                        width={120}
                                        height={60}
                                        className={styles.footerLogo}
                                    />
                                </div>
                            </div>
                            <h3 className={styles.columnTitle}>Get in Touch</h3>
                            <form onSubmit={handleSubmit} className={styles.emailForm}>
                                <input
                                    type="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={styles.emailInput}
                                    required
                                />
                                <button 
                                    type="submit" 
                                    className={styles.sendButton}
                                    aria-label="Subscribe to PISCESIA newsletter"
                                >
                                    Send
                                </button>
                            </form>
                        </div>

                        {/* About Column */}
                        <div className={styles.footerColumn}>
                            <h3 className={styles.columnTitle}>About Us</h3>
                            <ul className={styles.linksList}>
                                <li><Link href="/about/story" className={styles.footerLink}>Who we are</Link></li>
                                <li><Link href="/about/vision" className={styles.footerLink}>Vision & Mission</Link></li>
                                <li><Link href="/about/leadership" className={styles.footerLink}>Leadership</Link></li>
                                {/* <li><Link href="/about/certifications" className={styles.footerLink}>Certifications</Link></li> */}
                                {/* <li><Link href="/downloads" className={styles.footerLink}>Downloads</Link></li> */}
                            </ul>
                        </div>

                        {/* Insights Column */}
                        <div className={styles.footerColumn}>
                            <h3 className={styles.columnTitle}>Insights</h3>
                            <ul className={styles.linksList}>
                                <li><Link href="/projects" className={styles.footerLink}>Projects</Link></li>
                                <li><Link href="/blogs" className={styles.footerLink}>Blogs</Link></li>
                                <li><Link href="/newsroom" className={styles.footerLink}>Newsroom</Link></li>
                                <li><Link href="/culture" className={styles.footerLink}>PISCESIA Culture</Link></li>
                                <li><Link href="/careers" className={styles.footerLink}>Careers</Link></li>
                            </ul>
                        </div>

                        {/* Useful Links Column */}
                        <div className={styles.footerColumn}>
                            <h3 className={styles.columnTitle}>Useful Links</h3>
                            <ul className={styles.linksList}>
                                <li><Link href="/" className={styles.footerLink}>Home</Link></li>
                                <li><Link href="/services" className={styles.footerLink}>Verticals & Services</Link></li>
                                <li><Link href="/vendor-registration" className={styles.footerLink}>Vendor Registration</Link></li>
                                <li><Link href="/contact" className={styles.footerLink}>Contact</Link></li>
                                <li><Link href="/csr" className={styles.footerLink}>CSR</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <div className={styles.bottomFooter}>
                <div className={styles.container}>
                    <div className={styles.bottomContent}>
                                <div className={styles.copyright}>
            <p>© PISCESIA POWER TRANSMISSION PVT. LTD. 2025 - All Rights Reserved. ISO 9001:2008 Certified Company</p>
        </div>
        <div className={styles.contactInfo}>
            <span>piscesia.info@gmail.com</span>
            {/* <span>+91-9654714944</span> */}
        </div>
        <div className={styles.address}>
            <p>Corporate Office: 906, Wave Silver Tower, Sector-18, Noida – 201301, U.P. | Registered Office: Chamber No. 1, 9C/48, Vrindavan Yojna, R.B. Road, Lucknow – 226016, U.P. INDIA</p>
        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
